(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dns-icon-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = root => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const switches = [...root.querySelectorAll('[data-icon-switch]')];
    const panels = [...root.querySelectorAll('[data-icon-panel]')];
    const select = id => {
      switches.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.iconSwitch === id)));
      panels.forEach(panel => {
        const active = panel.dataset.iconPanel === id;
        panel.hidden = !active;
        const image = panel.querySelector('.dns-product-visual img');
        if (active && image && image.loading === 'lazy') image.loading = 'eager';
        panel.classList.toggle('is-entering', active);
      });
    };
    switches.forEach((button, index) => {
      button.addEventListener('click', () => select(button.dataset.iconSwitch));
      button.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        let next = event.key === 'Home' ? 0 : event.key === 'End' ? switches.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + switches.length) % switches.length;
        switches[next].focus();
        select(switches[next].dataset.iconSwitch);
      });
    });
    root.addEventListener('shopify:block:select', event => {
      const panel = event.target.closest('[data-icon-panel]');
      if (panel) select(panel.dataset.iconPanel);
    });
    const media = matchMedia('(prefers-reduced-motion: reduce)');
    const hero = root.querySelector('.dns-hero');
    const heroImage = root.querySelector('[data-hero-image] img');
    if (hero && heroImage && matchMedia('(pointer:fine)').matches) {
      let frame = 0;
      hero.addEventListener('pointermove', event => {
        if (media.matches || frame) return;
        frame = requestAnimationFrame(() => {
          const rect = hero.getBoundingClientRect();
          const x = ((event.clientX - rect.left) / rect.width - .5) * 10;
          const y = ((event.clientY - rect.top) / rect.height - .5) * 6;
          heroImage.style.transform = `scale(1.025) translate(${x}px, ${y}px)`;
          frame = 0;
        });
      });
      hero.addEventListener('pointerleave', () => { heroImage.style.transform = ''; });
      media.addEventListener('change', () => { if (media.matches) heroImage.style.transform = ''; });
    }
  };
  document.querySelectorAll('[data-icon-home]').forEach(setup);
  document.addEventListener('shopify:section:load', event => setup(event.target.querySelector('[data-icon-home]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dns-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dns-product-timer-slot')) {
    customElements.define('dns-product-timer-slot', class extends HTMLElement {
      constructor() {
        super();
        this.observer = new MutationObserver(() => this.moveTimer());
      }

      connectedCallback() {
        this.observer.disconnect();
        this.form = this.closest('form');
        const product = this.closest('[data-dns-product]');
        if (!product || !this.form || this.form.getAttribute('id') !== 'dns-product-form' || !product.contains(this.form)) return;

        this.observer.observe(this.form, { childList: true });
        this.moveTimer();
      }

      disconnectedCallback() {
        this.observer.disconnect();
        this.form = null;
      }

      moveTimer() {
        if (!this.isConnected || !this.form || this.closest('form') !== this.form) return;

        const wrapper = Array.from(this.form.children).find(child =>
          child !== this && (
            child.matches('.essential_countdown_timer') ||
            child.querySelector('.essential_countdown_timer') ||
            child.id.startsWith('countdown_timer_wrapper_') ||
            child.classList.contains('countdown_timer_wrapper') ||
            Array.from(child.classList).some(name => name.startsWith('countdown_timer_wrapper_'))
          )
        );
        if (wrapper) this.replaceChildren(wrapper);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dns-sale-countdown"]) return;
  try {
    
  if (!customElements.get('dns-sale-countdown')) {
    customElements.define('dns-sale-countdown', class extends HTMLElement {
      constructor() {
        super();
        this.timer = null;
        this.refresh = () => this.update();
      }

      connectedCallback() {
        this.hidden = true;
        const isoDate = this.dataset.endsAt || '';
        if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?(?:Z|[+-]\d{2}:\d{2})$/.test(isoDate)) return;

        this.deadline = Date.parse(isoDate);
        if (!Number.isFinite(this.deadline)) return;

        this.parts = {
          days: this.querySelector('[data-sale-days]'),
          hours: this.querySelector('[data-sale-hours]'),
          minutes: this.querySelector('[data-sale-minutes]'),
          seconds: this.querySelector('[data-sale-seconds]')
        };
        if (Object.values(this.parts).some(part => !part)) return;

        const locale = document.documentElement.lang || 'en';
        this.numbers = new Intl.NumberFormat(locale, {
          minimumIntegerDigits: 2,
          maximumFractionDigits: 0,
          useGrouping: false
        });
        const deadlineLabel = this.querySelector('[data-sale-deadline]');
        if (deadlineLabel) {
          const formattedDate = new Intl.DateTimeFormat(locale, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            timeZoneName: 'short'
          }).format(new Date(this.deadline));
          deadlineLabel.textContent = deadlineLabel.dataset.label.replace('__DNS_DATE__', formattedDate);
        }

        document.addEventListener('visibilitychange', this.refresh);
        this.update();
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.refresh);
      }

      update() {
        window.clearTimeout(this.timer);
        const remainingMs = this.deadline - Date.now();
        if (!this.isConnected || remainingMs <= 0) {
          this.hidden = true;
          document.removeEventListener('visibilitychange', this.refresh);
          return;
        }

        const remaining = Math.ceil(remainingMs / 1000);
        const values = {
          days: Math.floor(remaining / 86400),
          hours: Math.floor(remaining / 3600) % 24,
          minutes: Math.floor(remaining / 60) % 60,
          seconds: remaining % 60
        };
        Object.entries(values).forEach(([unit, value]) => {
          this.parts[unit].textContent = this.numbers.format(value);
        });
        this.hidden = false;
        this.timer = window.setTimeout(this.refresh, Math.min(1000, remainingMs));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('src');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


  } catch(e) { console.error(e); }
})();
})();
